var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgRequestedTripsIcon(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 31,
    height: 30,
    viewBox: "0 0 31 30",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    opacity: 0.8
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0.5,
    width: 30,
    height: 30,
    rx: 8,
    fill: "#7A59BF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M22.3103 15.6905C21.8603 19.133 18.4553 21.923 14.9828 21.923H9.98025C9.55566 21.9232 9.16217 21.7004 8.94394 21.3361C8.72572 20.9719 8.71482 20.5198 8.91525 20.1455L9.11775 19.763C9.33525 19.3926 9.33525 18.9335 9.11775 18.563C7.41304 15.8702 7.6793 12.3774 9.7725 9.97411C11.8657 7.57079 15.2888 6.82756 18.1902 8.14646C21.0916 9.46536 22.7823 12.5332 22.3478 15.6905H22.3103Z",
    fill: "#F8F7FD"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 12.5,
    cy: 15,
    r: 0.75,
    fill: "#9176CB"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 15.5,
    cy: 15,
    r: 0.75,
    fill: "#9176CB"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 18.5,
    cy: 15,
    r: 0.75,
    fill: "#9176CB"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRequestedTripsIcon);
export default __webpack_public_path__ + "static/media/requestedTripsIcon.d346cbdf8ec8613bb89df5bb4d232626.svg";
export { ForwardRef as ReactComponent };